import { Stack } from "@mui/material";
import { StyledTextDescribeModal, StyledTitleModal } from "@components/modal/publishAds/ConfirmPublishAds.modal";
import { useTranslation } from "react-i18next";

const RefreshAdModal = () => {
  const { t } = useTranslation();

  return (
    <Stack direction={"column"} justifyContent={"center"} alignItems={"center"} spacing={2} mb={3} mt={2}>
      <img src="/images/icon_refresh_blue.svg" alt="check" style={{ width: "56px", height: "47px", marginBottom: "1rem" }} />
      <StyledTitleModal>{t("multiDiffusion.tab.adStatus.toCorrectModal.refreshAdModal.title")}</StyledTitleModal>
      <StyledTextDescribeModal>{t("multiDiffusion.tab.adStatus.toCorrectModal.refreshAdModal.description")}</StyledTextDescribeModal>
    </Stack>
  );
};

export default RefreshAdModal;
